import { Avatar, Grid, ListItem, ListItemAvatar, ListItemText, styled } from '@mui/material';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { WsColors } from 'wisestep-base';

import { ActivateFeature } from '../../../components/ActivateFeature';
import { ISettingsMenuOption } from '../types';

const SettingsMenuItem = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  height: '100%',
  minHeight: 80,
  border: '2px solid' + WsColors.BorderGrey,
  borderRadius: theme.spacing(0.5),
  ':hover': {
    boxShadow: '1px 1px 5px' + WsColors.BorderGrey,
  },
}));

export interface ISettingsContentLayoutProps {
  options: ISettingsMenuOption[];
}

const SettingsContentLayout = ({ options }: ISettingsContentLayoutProps) => {
  const navigate = useNavigate();

  return (
    <Grid container rowGap={2} columnSpacing={2}>
      {options.map((option, i) => (
        <Grid key={i} item xs={6}>
          {option.SKU && !isEmpty(option.SKU) ? (
            <ActivateFeature feature={option.SKU}>
              <SettingsMenuItem
                onClick={() => {
                  option?.openInNewTab ? window.open(option.url, '_blank') : navigate(option.url);
                }}
              >
                {option.icon && (
                  <ListItemAvatar>
                    <Avatar>{option.icon}</Avatar>
                  </ListItemAvatar>
                )}
                <ListItemText
                  primaryTypographyProps={{ fontWeight: 700 }}
                  primary={option.label}
                  secondary={option.description}
                />
              </SettingsMenuItem>
            </ActivateFeature>
          ) : (
            <SettingsMenuItem
              onClick={() => {
                option?.openInNewTab ? window.open(option.url, '_blank') : navigate(option.url);
              }}
            >
              {option.icon && (
                <ListItemAvatar>
                  <Avatar>{option.icon}</Avatar>
                </ListItemAvatar>
              )}
              <ListItemText
                primaryTypographyProps={{ fontWeight: 700 }}
                primary={option.label}
                secondary={option.description}
              />
            </SettingsMenuItem>
          )}
        </Grid>
      ))}
    </Grid>
  );
};
export default SettingsContentLayout;
